import { useCallback, useState } from 'react';
import { findSnippetByLanguage, VersionedSnippet, VersionName } from '@cld/code-snippet-next';
import { SnippetLanguage } from '../types';

export const useSnippetState = (snippets: VersionedSnippet[], initialLanguage?: SnippetLanguage, initialVersion?: VersionName) => {
  const [language, setLanguage] = useState<string | undefined>(initialLanguage);
  const [version, setVersion] = useState<string | undefined>(initialVersion);

  const handleLangChange = useCallback(
    (currentLanguage: SnippetLanguage) => {
      const currentSnippet = findSnippetByLanguage(snippets, currentLanguage);
      setLanguage(currentLanguage);
      setVersion(currentSnippet?.versions[0].versionName);
    },
    [snippets]
  );

  return { language, setLanguage: handleLangChange, version, setVersion };
};
